<template>
  <div class="higher-search-wrap aud-manage-content">
    <!--大的查询集合-->
    <div class="big-terms-content">
      <!--大的查询集合switch-->
      <div
        class="big-switch-line"
        v-if="termsGroup.length > 1"
      ></div>
      <div
        class="big-switch-contents"
        v-if="termsGroup.length > 1"
      >
        <el-switch
          style="display: block"
          v-model="outOperator"
          active-color="#1980FF"
          inactive-color="#ff4949"
          active-text="且"
          inactive-value="or"
          active-value="and"
          @change="update"
          class="big-switch"
          inactive-text="或"
        >
        </el-switch>
      </div>
      <!--大的查询集合条件组  termsGroup 就是 forSonTerms-->
      <div
        class="big-term-content"
        v-for="(one, i) in termsGroup"
        :key="i"
      >
        <!--小的查询集合-->
        <div
          class="search-wrap"
          style="overflow:hidden;"
        >
          <div
            class=""
            :class="one | formatCusHigherSearchLine"
            v-if="one.terms.length > 1"
          ></div>
          <div
            class=""
            :class="one | formatCusHigherSearchAndOr"
            v-if="one.terms.length > 1"
          >
            <el-switch
              style="display: block"
              v-model="one.inOperator"
              active-color="#1980FF"
              inactive-color="#ff4949"
              @change="update"
              active-text="且"
              inactive-value="or"
              active-value="and"
              class="switch"
              inactive-text="或"
            >
            </el-switch>
          </div>
          <div class="search-terms-content">
            <div
              v-for="(item, index) in one.terms"
              :key="index"
              class="term-item"
            >
              <div
                class="block"
                style="text-align: left"
              >
                <!--级联选择器-->
                <el-cascader
                  filterable
                  :options="options"
                  v-model="item.selectedOptions"
                  class="first-attr first-cascader special-high-search-fir aud-first-attr"
                  @change="update(item)"
                >
                </el-cascader>
                <!--相对关系-->
                <relationship
                  @change="updates(item)"
                  v-model="item.relationship"
                  :relationOptions="item.relationOptions"
                  class="relationSelect"
                  v-if="
                    item.selectedOptions[0] !== 'group' &&
                    item.selectedOptions[0] !== 'event' &&
                    item.selectedOptions[0] !== 'follow_public'"
                >
                </relationship>
                <!--值-->
                <!--<values v-model="item.value" :realValue="item.value" @getQrcodes="getQrcodes" :item="item"></values>-->
                <!--判断是什么类型 input select等-->
                <!--select-->
                <!--属性select-->
                <el-select
                  filterable
                  @change="update"
                  class="ifSelect"
                  v-if="item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'select' &&
                    item.selectedOptions[1].split('@')[0] !== 'source_id' &&
                    item.selectedOptions[1].split('@')[0] !== 'stage_id' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not_empty' &&
                    item.selectedOptions[0] === 'attr'"
                  v-model="item.value"
                  placeholder="请选择查询内容"
                >
                  <el-option
                    v-for="i in item.option"
                    :key="i"
                    :label="i"
                    :value="i"
                  >
                  </el-option>
                </el-select>
                <!--属性radio-->
                <el-select
                  filterable
                  @change="update"
                  class="ifSelect"
                  v-if="
                    item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[0] !== 'source_id' &&
                    item.selectedOptions[1].split('@')[0] !== 'stage_id' &&
                    item.selectedOptions[1].split('@')[1] === 'radio' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not_empty' &&
                    item.selectedOptions[0] === 'attr'"
                  v-model="item.value"
                  placeholder="请选择查询内容"
                >
                  <el-option
                    v-for="i in item.option"
                    :key="i"
                    :label="i"
                    :value="i"
                  >
                  </el-option>
                </el-select>
                <!--属性(初始来源)-->
                <el-select
                  filterable
                  @change="update"
                  class="ifSelect"
                  v-if="item.selectedOptions.length > 0 &&
                  item.selectedOptions[1].split('@')[0] === 'source_id' &&
                  item.selectedOptions[1].split('@')[1] === 'dict' &&
                  item.relationship !== 'empty' &&
                  item.relationship !== 'not_empty' &&
                  item.selectedOptions[0] === 'attr'"
                  v-model="item.value"
                  placeholder="请选择查询内容"
                >
                  <el-option
                    v-for="i in item.option"
                    :key="i.id"
                    :label="i.name"
                    :value="i.id"
                  >
                  </el-option>
                </el-select>
                <!--属性(客户等级)-->
                <el-select
                  filterable
                  @change="update"
                  class="ifSelect"
                  v-if="item.selectedOptions.length > 0 &&
                  item.selectedOptions[1].split('@')[0] === 'stage_id' &&
                  item.selectedOptions[1].split('@')[1] === 'dict' &&
                  item.relationship !== 'empty' &&
                  item.relationship !== 'not_empty' &&
                  item.selectedOptions[0] === 'attr'"
                  v-model="item.value"
                  placeholder="请选择查询内容"
                >
                  <el-option
                    v-for="i in item.option"
                    :key="i.id"
                    :label="i.name"
                    :value="i.id"
                  >
                  </el-option>
                </el-select>
                <el-autocomplete
                  @focus="getMyOptions(item)"
                  @select="getMyOptionsChange(item)"
                  v-if="item.selectedOptions.length > 0 &&
                  item.selectedOptions[1].split('@')[0] !== 'stage_id' &&
                  item.selectedOptions[1].split('@')[1] === 'model' &&
                  item.relationship !== 'empty' &&
                  item.relationship !== 'not_empty' &&
                  item.selectedOptions[0] === 'attr'"
                  v-model="item.value"
                  :fetch-suggestions="querySearchAsyncModel"
                  placeholder="请输入内容"
                ></el-autocomplete>
                <!--属性(多选)-->
                <el-select
                  filterable
                  @change="update"
                  class="ifSelect"
                  v-if="item.selectedOptions.length > 0 &&
                  item.selectedOptions[1].split('@')[0] !== 'stage_id' &&
                  item.selectedOptions[1].split('@')[1] === 'multipleSelect' &&
                  item.relationship !== 'empty' &&
                  item.relationship !== 'not_empty' &&
                  item.selectedOptions[0] === 'attr'"
                  v-model="item.value"
                  placeholder="请选择查询内容"
                >
                  <el-option
                    v-for="i in item.option"
                    :key="i"
                    :label="i"
                    :value="i"
                  >
                  </el-option>
                </el-select>
                <!-- 属性数字 -->
                <el-input-number
                  v-if="
                    item.selectedOptions[0] === 'attr' &&
                    item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'number' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'gtele' &&
                    item.relationship !== 'not_empty'"
                  controls-position="right"
                  class="input-number"
                  @blur="update"
                  type="number"
                  v-model.trim="item.value"
                  placeholder="请输入数字"
                >
                </el-input-number>
                <el-input-number
                  v-if="
                    item.selectedOptions[0] === 'attr' &&
                    item.relationship === 'gtele' &&
                    item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'number' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not_empty'"
                  controls-position="right"
                  class="input-number"
                  @input="update"
                  maxlength="20"
                  type="number"
                  v-model.trim="item.startValue"
                  placeholder="请输入数字"
                  @blur="inputChange(item.startValue)"
                >
                </el-input-number>
                <span v-if="
                    item.selectedOptions[0] === 'attr' &&
                    item.relationship === 'gtele' &&
                    item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'number' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not_empty'">~</span>
                <el-input-number
                  v-if="
                    item.selectedOptions[0] === 'attr' &&
                    item.relationship === 'gtele' &&
                    item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'number' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not_empty'"
                  controls-position="right"
                  class="input-number"
                  @input="update"
                  maxlength="20"
                  type="number"
                  @blur="inputChange(item.endValue)"
                  v-model.trim="item.endValue"
                  placeholder="请输入数字"
                >
                </el-input-number>
                <!--群组-->
                <el-cascader
                  ref="select"
                  filterable
                  v-if="
                    item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'select' &&
                    item.selectedOptions[0] === 'group'"
                  :options="item.option"
                  v-model="item.value"
                  style="padding-left: 0;"
                  @change="update"
                >
                </el-cascader>
                <!-- 标签 -->
                <el-autocomplete
                  @change="sendValues"
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'select' && item.selectedOptions[0] === 'aud_portary' && item.relationship !== 'empty' && item.relationship !== 'not_empty'"
                  v-model="item.value"
                  :fetch-suggestions="querySearchAsyncTag"
                  placeholder="请输入内容"
                ></el-autocomplete>
                <!--关注公众号-->
                <el-select
                  @change="eventChange(item)"
                  filterable
                  class="ifSelect"
                  v-if="item.selectedOptions.length > 0 &&
                  item.selectedOptions[1].split('@')[1] === 'select' &&
                  item.selectedOptions[0] === 'follow_public'"
                  v-model="item.value"
                  placeholder="请选择公众号"
                >
                  <el-option
                    v-for="i in item.option"
                    :key="i.value"
                    :label="i.label"
                    :value="i.value"
                  >
                  </el-option>
                </el-select>
                <!--input-->
                <el-input
                  maxlength="200"
                  @input="update"
                  v-if="item.selectedOptions[0] !== 'customer_kpi' &&
                  item.selectedOptions.length > 0 &&
                  item.selectedOptions[1].split('@')[1] === 'input' &&
                  item.relationship !== 'empty' &&
                  item.relationship !== 'not_empty'"
                  v-model.trim="item.value"
                  placeholder="请输入查询内容"
                >
                </el-input>

                <!--受众身份-->
                <el-input
                  maxlength="200"
                  @input="update"
                  v-if="item.selectedOptions[0] === 'wechat_open_id' &&
                  item.selectedOptions.length > 0 &&
                  item.selectedOptions[1].split('@')[1] === 'openid' &&
                  item.relationship !== 'empty' &&
                  item.relationship !== 'not_empty'"
                  v-model.trim="item.value"
                  placeholder="请输入查询内容"
                >
                </el-input>

                <!-- 数字 -->
                <el-input-number
                  v-if="
                    item.selectedOptions[0] === 'customer_kpi' &&
                    item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'number' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not_empty' &&
                    item.relationship !== 'gtele'"
                  controls-position="right"
                  class="input-number"
                  @input="update"
                  @blur="inputChange(item.value)"
                  type="number"
                  v-model.trim="item.value"
                  placeholder="请输入数字"
                >
                </el-input-number>
                <div
                  v-if="
                    item.selectedOptions[0] === 'customer_kpi' &&
                    item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'number' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not_empty' &&
                    item.relationship === 'gtele'"
                  class="el-input-content"
                >
                  <el-input-number
                    controls-position="right"
                    class="input-number-gtele-kpi"
                    @input="update"
                    maxlength="20"
                    type="number"
                    v-model.trim="item.startValue"
                    placeholder="请输入数字"
                    @blur="inputChange(item.startValue)"
                  >
                  </el-input-number>
                  ~
                  <el-input-number
                    controls-position="right"
                    class="input-number-gtele-kpi"
                    @input="update"
                    maxlength="20"
                    type="number"
                    @blur="inputChange(item.endValue)"
                    v-model.trim="item.endValue"
                    placeholder="请输入数字"
                  >
                  </el-input-number>
                </div>
                <!--datePicker-->
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'datePicker' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not_empty' &&
                    item.relationship !== 'gtele'"
                  v-model="item.value"
                  type="date"
                  class="dateTimePicker"
                  @change="update"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
                <!--dateTimePicker-->
                <el-date-picker
                  v-if="
                    item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'dateTimePicker' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not_empty' &&
                    item.relationship !== 'gtele'"
                  v-model="item.value"
                  type="datetime"
                  class="dateTimePicker"
                  @change="update"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择时间和日期"
                >
                </el-date-picker>
                <!--区间类日期选择-->
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'datePicker' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not_empty' &&
                    item.relationship === 'gtele'"
                  v-model="item.startValue"
                  type="date"
                  class="dateTimePicker"
                  @change="update"
                  @blur="chooseStartTime(item)"
                  value-format="yyyy-MM-dd"
                  placeholder="选择开始日期"
                >
                </el-date-picker>
                <span
                  style="padding: 0 6px"
                  v-if="item.selectedOptions.length > 0 &&
                  item.selectedOptions[1].split('@')[1] === 'datePicker' &&
                  item.relationship !== 'empty' &&
                  item.relationship !== 'not_empty' &&
                  item.relationship === 'gtele'"
                >
                  至
                </span>
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'datePicker' && item.relationship !== 'empty' && item.relationship !== 'not_empty' && item.relationship === 'gtele'"
                  v-model="item.endValue"
                  type="date"
                  class="dateTimePicker"
                  @blur="chooseEndTime(item)"
                  @change="update"
                  value-format="yyyy-MM-dd"
                  placeholder="选择结束日期"
                >
                </el-date-picker>
                <!--区间类日期时间选择-->
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'dateTimePicker' && item.relationship !== 'empty' && item.relationship !== 'not_empty' && item.relationship === 'gtele'"
                  v-model="item.startValue"
                  type="datetime"
                  class="dateTimePicker"
                  @change="update"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择开始时间和日期"
                >
                </el-date-picker>
                <span
                  style="padding: 0 6px"
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'dateTimePicker' && item.relationship !== 'empty' && item.relationship !== 'not_empty' && item.relationship === 'gtele'"
                >至</span>
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'dateTimePicker' && item.relationship !== 'empty' && item.relationship !== 'not_empty' && item.relationship === 'gtele'"
                  v-model="item.endValue"
                  type="datetime"
                  class="dateTimePicker"
                  @change="update"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择结束时间和日期"
                >
                </el-date-picker>
                <!--addressPicker-->
                <el-cascader
                  v-if="item.selectedOptions.length > 0 &&
                  item.selectedOptions[1].split('@')[1] === 'addressPicker' &&
                  item.relationship !== 'empty' &&
                  item.relationship !== 'not_empty'"
                  class="area"
                  size="large"
                  :options="addressOptions"
                  v-model="item.value"
                  @change="update"
                >
                </el-cascader>
                <div
                  class="remove-btn"
                  @click="removeTermItem(index, i)"
                  v-if="(num > 1 && isAnalyse === false) ||
                  (isAnalyse === true)"
                >
                  <i
                    class="el-icon-close"
                    title="删除当前条件"
                  ></i>
                </div>
                <!--如果是客户事件-->
                <div
                  class="action-select"
                  v-if="item.selectedOptions[0] == 'event'"
                >
                  <el-row
                    class="action-select-row"
                    style="height: 32px;line-height: 32px"
                  >
                    <el-checkbox
                      @change="changeLimitEventTime(item)"
                      v-model="item.eventLimitTime"
                    >
                      限制起止时间
                    </el-checkbox>
                    <el-checkbox
                      @change="changeLimitEventAttr(item)"
                      v-if="item.selectedOptions[1] !== 'order'"
                      v-model="item.eventLimitAttr"
                    >
                      限制事件属性
                    </el-checkbox>
                    <el-checkbox
                      @change="changeLimitEventAttr(item)"
                      v-model="item.eventLimitTimes"
                    >
                      限制次数
                    </el-checkbox>
                  </el-row>
                  <!--限制时间-->
                  <el-row
                    class="action-select-row limit-time"
                    style="line-height: 40px"
                    v-if="item.eventLimitTime"
                  >
                    <el-col
                      :span="2"
                      class="action-select-row-title"
                    >
                      起止时间:
                    </el-col>
                    <el-col
                      :span="22"
                      v-if="item.eventLimitTime"
                    >
                      <el-date-picker
                        v-model="item.eventDateStart"
                        type="datetime"
                        time-arrow-control
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="judgeDateStart(item)"
                        class="event-son-input arrowPositionSelect date-time-search font-size-14"
                        placeholder="选择时间和日期"
                      >
                      </el-date-picker>
                      -
                      <el-date-picker
                        value-format="yyyy-MM-dd HH:mm:ss"
                        v-model="item.eventDateEnd"
                        type="datetime"
                        time-arrow-control
                        @change="judgeDate(item)"
                        class="event-son-input arrowPositionSelect date-time-search font-size-14"
                        placeholder="选择时间和日期"
                      >
                      </el-date-picker>
                    </el-col>
                  </el-row>
                  <!--限制次数-->
                  <el-row
                    class="action-select-row"
                    style="line-height: 40px;margin: 5px 0"
                    v-if="item.eventLimitTimes"
                  >
                    <el-col
                      :span="2"
                      class="action-select-row-title"
                    >
                      发生次数:
                    </el-col>
                    <el-col
                      :span="22"
                      style=""
                    >
                    <!-- v-model="item.eventTimeRelation" -->
                      <el-select
                        @change = "sendValues($event, 'eventTimeRelation')"
                        style="width: auto;margin-right: 7px"
                        class="event-son-input arrowPositionSelect happend-times font-size-14"
                        v-model="item.eventTimeRelation"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="k in eventTimesList"
                          :key="k.value"
                          :label="k.label"
                          :value="k.value"
                        >
                        </el-option>
                      </el-select>
                      <el-input-number
                        @input="sendValues"
                        :min="1"
                        :max="100000000"
                        controls-position="right"
                        placeholder="请输入次数"
                        v-if="item.eventTimeRelation === 'gtele'"
                        class="event-son-input font-size-14"
                        v-model.trim="item.happenedTimesStart"
                      >
                      </el-input-number>
                      <span
                        v-if="item.eventTimeRelation === 'gtele'"
                        style="padding-left: 0"
                      >
                        —
                      </span>
                      <el-input-number
                        @input="sendValues"
                        :min="1"
                        :max="100000000"
                        controls-position="right"
                        placeholder="请输入次数"
                        class="event-son-input font-size-14"
                        v-if="item.eventTimeRelation === 'gtele'"
                        v-model.trim="item.happenedTimesEnd"
                      >
                      </el-input-number>
                      <el-input-number
                        @input="sendValues"
                        :min="1"
                        :max="100000000"
                        controls-position="right"
                        placeholder="请输入次数"
                        class="event-son-input font-size-14"
                        v-if="item.eventTimeRelation !== 'gtele' &&
                        item.eventTimeRelation !== 'at_least_once' &&
                        item.eventTimeRelation !== 'no_once'"
                        v-model.trim="item.happenedTimes"
                      >
                      </el-input-number>
                    </el-col>
                  </el-row>
                  <!--限制属性-->
                  <div v-if="item.eventLimitAttr">
                    <el-row
                      class="action-select-row limit-attr"
                      style="line-height: 40px"
                    >
                      <el-col
                        :span="24"
                        v-for="(itemAttr, ai) in item.eventAttrOptions"
                        :key="ai"
                      >
                        <el-col
                          :span="2"
                          class="action-select-row-title"
                        >
                          <span style="padding-left: 0">
                            <span
                              style="padding-left: 0"
                              v-if="ai === 0"
                            >
                              事件属性:
                            </span>
                            <span
                              style="padding-left: 0"
                              v-if="ai !== 0"
                            >
                              &nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                          </span>
                        </el-col>
                        <el-col :span="22" style="margin-bottom: 10px">
                        <!--事件属性名字-->
                         <!-- v-model="itemAttr.attributeContent" -->
                         <el-select
                          filterable
                          @change="changeLimitRelation(item, itemAttr)"
                          v-if="item.selectedOptions.length > 0 &&
                          item.selectedOptions[0] === 'event'"
                          class="event-son-input arrowPositionSelect"
                          v-model="itemAttr.attributeContent"
                          placeholder="请选择事件属性"
                          @visible-change="visibleChange" @focus="focusWay" ref="selectDom1">
                          <el-option
                            v-for="k in item.eventAttributeList"
                            :key="k.attr_identity"
                            :label="k.attr_name"
                            :value="k.attr_identity"
                          >
                          </el-option>
                        </el-select>
                        <!--相对关系-->
                        <el-select
                          @change="sendValues"
                          class="event-son-input arrowPositionSelect limit-relation aresBottom"
                          v-model="itemAttr.attributeRelation"
                          placeholder="相对关系"
                        >
                          <el-option
                            v-for="k in itemAttr.relationOptions"
                            :key="k.value"
                            :label="k.label"
                            :value="k.value"
                          >
                          </el-option>
                        </el-select>
                        <!--地理位置-->
                        <el-cascader
                                v-if="itemAttr.attributeContent === 'address' &&
                                   (itemAttr.attributeRelation !== 'empty' && itemAttr.attributeRelation !== 'not_empty')"
                                filterable
                                class="first-attr behavior-dimension area"
                                size="large"
                                :options="addressOptions"
                                v-model="itemAttr.attributeValue"
                        ></el-cascader>
                        <!--值-->
                        <!-- <el-select
                          filterable
                          @change="sendValues"
                          v-if="itemAttr.attributeRelation !== 'empty' &&
                          itemAttr.attributeRelation !== 'not_empty' &&
                          itemAttr.attributeContent === 'source' &&
                          item.attr !== 'event'"
                          class="event-son-input arrowPositionSelect limit-relation"
                          v-model="itemAttr.attributeValue"
                          placeholder="选择来源">
                          <el-option
                            v-for="k in itemAttr.sources"
                            :key="k.value"
                            :label="k.label"
                            :value="k.value">
                          </el-option>
                        </el-select>
                        <el-select
                          filterable
                          @change="sendValues"
                          v-if="itemAttr.attributeRelation !== 'empty' &&
                          itemAttr.attributeRelation !== 'not_empty' &&
                          itemAttr.attributeContent === 'source' &&
                          item.attr === 'event'"
                          class="event-son-input arrowPositionSelect limit-relation"
                          v-model="itemAttr.attributeValue"
                          placeholder="选择来源">
                          <el-option
                            v-for="k in itemAttr.sources"
                            :key="k.label"
                            :label="k.label"
                            :value="k.label">
                          </el-option>
                        </el-select> -->
                        <el-autocomplete
                          @change="sendValues"
                          v-if="itemAttr.attr_type === 'dictionary'"
                          v-model="itemAttr.attributeValue"
                          @focus="setItemAttr(item, itemAttr)"
                          :fetch-suggestions="querySearchAsync"
                          placeholder="请输入内容"
                          @select="handleSelect"
                          suffix-icon="el-icon-arrow-down"
                        >
                        </el-autocomplete>
                        <el-input
                          maxlength="200"
                          @input="update"
                          v-if="itemAttr.attributeRelation !== 'empty' &&
                          itemAttr.attr_type !== 'dictionary' &&
                          itemAttr.attributeRelation !== 'not_empty' &&
                          itemAttr.attributeContent !== 'source' &&
                          itemAttr.attr_type === 'txt'"
                          v-model.trim="itemAttr.attributeValue"
                          placeholder="请输入限制内容"
                        >
                        </el-input>
                        <el-input-number
                          @input="update"
                          :min="1"
                          :max="100000000"
                          controls-position="right"
                          placeholder="请输入次数"
                          class="event-son-input font-size-14"
                          v-if="itemAttr.attributeRelation !== 'empty' &&
                          itemAttr.attributeRelation !== 'gtele' &&
                          itemAttr.attributeRelation !== 'not_empty' &&
                          itemAttr.attr_type === 'money'"
                          v-model.trim="itemAttr.attributeValue"
                        >
                        </el-input-number>
                        <el-input-number
                          @input="update"
                          :min="1"
                          :max="100000000"
                          controls-position="right"
                          placeholder="请输入次数"
                          class="event-son-input font-size-14"
                          v-if="itemAttr.attributeRelation !== 'empty' &&
                          itemAttr.attributeRelation !== 'gtele' &&
                          itemAttr.attributeRelation !== 'not_empty' &&
                          itemAttr.attr_type === 'number'"
                          v-model.trim="itemAttr.attributeValue"
                        >
                        </el-input-number>
                        <el-input-number
                          @input="update"
                          :min="1"
                          :max="100000000"
                          controls-position="right"
                          placeholder="请输入次数"
                          class="event-son-input font-size-14"
                          v-if="itemAttr.attributeRelation !== 'empty' &&
                          itemAttr.attributeRelation === 'gtele' &&
                          itemAttr.attributeRelation !== 'not_empty' &&
                          itemAttr.attr_type === 'money'"
                          v-model.trim="itemAttr.attributeValueStart"
                        >
                        </el-input-number>
                        <span v-if="itemAttr.attributeRelation !== 'empty' &&
                          itemAttr.attributeRelation === 'gtele' &&
                          itemAttr.attributeRelation !== 'not_empty' &&
                          itemAttr.attr_type === 'money'">
                          -
                        </span>
                        <el-input-number
                          @input="update"
                          :min="1"
                          :max="100000000"
                          controls-position="right"
                          placeholder="请输入次数"
                          class="event-son-input font-size-14"
                          v-if="itemAttr.attributeRelation !== 'empty' &&
                          itemAttr.attributeRelation === 'gtele' &&
                          itemAttr.attributeRelation !== 'not_empty' &&
                          itemAttr.attr_type === 'money'"
                          v-model.trim="itemAttr.attributeValueEnd"
                        >
                        </el-input-number>
                        <div
                          class="remove-btn remove-btn-attribute"
                          @click="removeAttributeItem(item, ai)"
                          v-if="(item.eventAttrOptions.length > 1 &&
                          isAnalyse === false) ||
                          (isAnalyse === true)"
                        >
                          <i
                            class="el-icon-error"
                            title="删除当前条件"
                          >
                          </i>
                        </div>
                        </el-col>
                      </el-col>
                    </el-row>
                    <el-row
                      v-if="item.eventAttrOptions.length < 8 &&
                      item.eventAttrOptions.length > 0"
                      class="add-new-terms"
                    >
                      <div
                        class="add-new-term-btn add-new-term-btn-attribute"
                        @click="addNewEventAttribute(item)"
                      >
                        <i class="el-icon-plus">
                        </i>
                        添加事件属性限制
                      </div>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="add-new-terms"
          v-if="one.terms.length > 0"
        >
          <div
            class="add-new-term-btn"
            @click="addNewTerm(i)"
          >
            <i class="el-icon-circle-plus-outline"></i>
            增加一个条件
          </div>
        </div>
      </div>
    </div>
    <!--增加一组条件按钮-->
    <div class="add-one-group-terms">
      <div
        class="add-one-group-terms-btn"
        @click="addNewTermGroup"
      >
        <i class="el-icon-circle-plus-outline"></i>
        增加一组条件
      </div>
    </div>
  </div>
</template>

<script>
import { regionData, CodeToText, TextToCode, regionDataPlus } from 'element-china-area-data'
import { getCustomerAttributeList, getSourceData, getBigWheelList, getMessageListForNode, getGroupList, getCustomerEventList, getWechatPublicListAll, WePagesList } from '@/api/customer.js'
import { getCusAttrList, getAudTagList, getAudGroupList, getAudGroupGroupList, getAudHigSearDicList, getCustomerSources, getCusStageList, getMyAboutModelList, getCusEventList, getCusEventGroupList } from '@/api/set.js'
import { mapGetters, mapMutations } from 'vuex'
import relationship from './../common/higher-search-relationship.vue'
import {  higherAduRelateReversalOne, higherAduEventAttrOptions, higherAduSearchOptions, higherAduEventTimesList,
  higherAduAboutModels, higherAduRelationOptions, higherAduPublicReplyTypes, higherAduRelateOpsOne,
  higherAduRelateOpsTwo, higherAduRelateOpsThree, higherAduRelateOpsFour, higherInitTermGroupObj,
  initItemTermsObj, higherAduRelateOpsFive, higherAduRelateOpsSix, selDicAddList, optionsValueArr,
  higherAduRelateOpsSeven, multipleModelList, higherAduRelateOpsEight, datePickerArr

} from './constant'
// import values from './../common/higher-search-values.vue'
import { resetAttr } from '@/api/publicMethods'
export default {
  name: '',
  props: ['forSonTerms', 'allRelationship', 'allRelationshipSearch', 'modelId', 'isAnalyse'],
  data () {
    return {
      queryItem: {},
      dicList: [],
      eventTimesList:[],
      tmp_qrcode: null,
      selectDom_1: null,
      changed: false,
      qrcodePval: '',
      wechatPublic: [],
      wepage: [],
      qrcodes: [],
      offlineQrcodes: [],
      templates: [],
      activities: [],
      aboutModels: higherAduAboutModels(),
      public_reply_types: higherAduPublicReplyTypes,
      sms: [],
      outOperator: this.allRelationship,
      relationshipUse: '',
      addressOptions: regionDataPlus,
      options: [{
        value: 'attr',
        label: '受众属性',
        children: []
      },
      {
        value: 'event',
        label: '受众事件',
        children: []
      },
      {
        value: 'group',
        label: '受众群组',
        children: []
      },
      {
        value: 'aud_portary',
        label: '受众画像',
        children: [{
          label: '标签',
          value: 'tag@select',
          identity: 'tag'
        }]
      },
      {
        value: 'customer_kpi',
        label: '受众关键指标',
        children: [{
          label: '活跃度',
          value: 'activity@number',
          identity: 'activity'
        },
        {
          label: '7天活跃度',
          value: 'seven_activity@number',
          identity: 'seven_activity'
        },
        {
          label: '30天活跃度',
          value: 'thirty_activity@number',
          identity: 'thirty_activity'
        },
        {
          label: '价值评分',
          value: 'value_scoring@number',
          identity: 'value_scoring'
        },
        {
          label: '资料评分',
          value: 'score@number',
          identity: 'score'
        }
        ]
      },
      {
        value: 'follow_public',
        label: '关注公众号',
        children: [{
          label: '当前关注',
          value: 'follow_now@select',
          identity: 'means_integrate'
        },
        {
          label: '从未关注',
          value: 'follow_never@select',
          identity: 'follow_never'
        },
        {
          label: '取消关注',
          value: 'follow_cancel@select',
          identity: 'follow_cancel'
        }
        ]
      },
      {
        value: 'wechat_open_id',
        label: '受众身份',
        children: [{
          label: '微信openId',
          value: 'openId@input',
          identity: 'openId'
        },]
      }
      ],
      relationOptions: [{
        value: '=',
        label: '等于'
      }, {
        value: '!=',
        label: '不等于'
      }, {
        value: 'contain',
        label: '包含'
      }, {
        value: 'not contain',
        label: '不包含'
      }, {
        value: 'empty',
        label: '为空'
      },
      {
        value: 'not_empty',
        label: '不为空'
      }
      ],
      relation: '',
      ifSelect: '',
      ifSelectOptions: [],
      queryData: [],
      ifInput: '',
      ifRadio: '',
      termsGroup: JSON.parse(JSON.stringify(this.forSonTerms)),
      search: {}
    }
  },
  components: {
    'relationship': relationship
  },
  watch: {
    // forSonTerms: function (val) {
    //   this.termsGroup = val
    // },
    forSonTerms: {
      handler(val) {
        this.eventTimesList =  higherAduEventTimesList()
        if(val.constructor === Array) {
          this.termsGroup = val
        } else {
          this.termsGroup = JSON.parse(val).termsGroup
        }
        // console.log(this.termsGroup, "this.termsGroup传过来参数---")
      },
      deep:true,
      immediate:true
    },
    allRelationship: function (val) {
      this.outOperator = val
    },
    modelId (val) {
      this.load(val)
    }
  },
  computed: {
    ...mapGetters([
      'getQuery',
      'getEventLimitAttrItemAttr',
      'getEventLimitAttrItem'
    ]),
    num () {
      let num = 0
      for (let item of this.termsGroup) {
        num = num + item.terms.length
      }
      return num
    },
    nums () {
      let nums = 0
      for (let item of this.termsGroup) {
        for (let one of item.terms) {
          nums = nums + one.eventAttrOptions.length
        }
      }
      return nums
    },
    allTerms () {
      let allTerms = {}
      allTerms.allRelationship = this.outOperator
      allTerms.termsGroup = this.termsGroup
      return allTerms
    }
  },
  methods: {
    ...mapMutations([
      'setEventLimitAttrItemAttr',
      'setEventLimitAttrItem'
    ]),
    focusWay () {
      if (this.selectDom_1) {
        this.$refs['selectDom1'][0].blur()
      }
    },
    visibleChange (val) {
      setTimeout(()=> {
        this.selectDom_1 = val
      },0)
    },
    inputChange (value) {
      if (value.length > 20) {
        value.substr(0, 20)
        _g.toastMsg('error', '输入数字位数不能大于20')
      }
    },
    // item、itemAttr存入vuex
    setItemAttr (item, itemAttr) {
      this.setEventLimitAttrItemAttr(itemAttr)
      this.setEventLimitAttrItem(item)
    },
    getMyOptions (item) {
      this.queryItem = item
      // this.querySearchAsyncModel()
    },
    getMyOptionsChange (item) {
      for (let one of this.queryData) {
        if (item.value == one.value) {
          item.modelItemId = one.id
        }
      }
    },
    // 请求模型关联数据
    querySearchAsyncModel (queryString, cb) {
      let str = ''
      if (this.queryItem.selectedOptions[0] !== 'event') {
        str = this.queryItem.selectedOptions[1].split('@')
      }
      let _this = this
      this.queryItem.type = str[1]
      for (let one of _this.options) {
        for (let i in one.children) {
          // 处理属性的option
          if (one.value === 'attr') {
            if (str[0] === one.children[i].identity) {
              if (str[1] === 'model') {
                let modelId = JSON.parse(one.children[i].options)[0].modelId
                let identity = JSON.parse(one.children[i].options)[2].identity
                getMyAboutModelList(modelId, identity, queryString).then((res) => {
                  if (res.data.code == 200) {
                    // this.queryItem.option = res.data.result.list
                    _this.queryData = res.data.result.list
                    cb(res.data.result.list)
                  }
                })
              }
            }
          }
        }
      }
    },
    // 请求标签数据
    querySearchAsyncTag (queryString, cb) {
      let modelId = ''
      if (this.$route.params.id) {
        modelId = this.$route.params.id
      } else {
        modelId = this.modelId
      }
      getAudTagList(modelId, queryString, 1, 10).then((res) => {
        if (res.data.code == 200) {
          let dicList = []
          for (let one of res.data.result.list) {
            one.value = one.name
          }
          dicList = res.data.result.list
          cb(dicList)
        }
      })
    },
    // 请求事件限制属性的字典类型数据
    querySearchAsync (queryString, cb) {
      let arr = this.getEventLimitAttrItemAttr
      let itemArr = this.getEventLimitAttrItem
      let dicList = []
      let modelId = ''
      getAudHigSearDicList(itemArr.selectedOptions[2], arr.attr_identity, queryString, modelId).then((res) => {
        if (res.data.code == 200) {
          for (let one of res.data.result) {
            one.value = one.propertyValue
          }
          dicList = res.data.result
          cb(dicList)
        }
      })
    },
    handleSelect (item) {
    },
    // 处理限制事件时间
    changeLimitEventTime (item) {
      if (item.eventLimitTime === false) {
        item.eventDateStart = ''
        item.eventDateEnd = ''
      }
      this.sendValues()
    },
    // 处理限制事件属性
    changeLimitEventAttr (item) {
      if (!item.eventLimitAttr) {
        // 当item.eventLimitAttr为false时，也就是不选中  限制事件属性  时，重置筛选条件
        item.eventAttrOptions = [{
          attributeContent: '',
          relationOptions: [],
          eventAttrValueOptions: [],
          attributeRelation: '',
          attr_identity: '',
          attrValTimeStart: '',
          attrValTimeEnd: '',
          attributeValue: '',
          eventTimeRelation:''
        }]
      }
      if (!item.eventLimitTimes) {
        // 当item.eventLimitTimes为false时，也就是不选中  限制次数时，重置筛选条件
        item.eventTimeRelation = null
        item.happenedTimes = null
      }
      this.sendValues()
    },
    // 判断限制时间开始时间不能大于结束时间
    judgeDate (item) {
      if (Date.parse(new Date(item.eventDateStart)) > Date.parse(new Date(item.eventDateEnd))) {
        item.eventDateEnd = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
      this.sendValues()
    },
    // 判断限制时间开始时间不能大于结束时间
    judgeDateStart (item) {
      if (Date.parse(new Date(item.eventDateStart)) > Date.parse(new Date(item.eventDateEnd))) {
        item.eventDateEnd = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
      this.sendValues()
    },
    // 判断下单时间开始时间不能大于结束时间
    judgeDatesStart (item) {
      if (Date.parse(new Date(item.attrValTimeStart)) > Date.parse(new Date(item.attrValTimeEnd))) {
        item.attrValTimeEnd = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
      this.sendValues()
    },
    // 判断下单时间开始时间不能大于结束时间
    judgeDates (item) {
      if (Date.parse(new Date(item.attrValTimeStart)) > Date.parse(new Date(item.attrValTimeEnd))) {
        item.attrValTimeEnd = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
      this.sendValues()
    },
    // 删除属性限制
    removeAttributeItem (item, ai) {
      item.eventAttrOptions.splice(ai, 1)
    },
    // 添加属性限制
    addNewEventAttribute (item) {
      item.eventAttrOptions.push({
        attributeContent: '',
        relationOptions: [],
        sources: [],
        eventAttrValueOptions: [],
        attributeRelation: '',
        attr_type: '',
        attr_identity: '',
        attrValTimeStart: '',
        attrValTimeEnd: '',
        attributeValue: ''
      })
    },
    // 级联选择之后加载限制属性相对关系
    changeLimitRelations (item) {
      resetAttr(item)
      // item.attributeValue = ''
      // item.attrValTimeStart = ''
      // item.attrValTimeEnd = ''
      // item.attributeRelation = ''
      // item.attributeValueStart = ''
      // item.attributeValueEnd = ''
      if (item.attributeContent[0] === 'goods_info' || item.attributeContent[0] === 'order_info' || item.attributeContent[0] === 'receive_goods_info') {
        item.relationOptions = higherAduRelateOpsOne()
      }
      if (item.attributeContent[1] === 'order_time') {
        item.relationOptions = higherAduRelateOpsTwo()
      }
      if (item.attributeContent[0] === 'statistics_info') {
        if (item.attributeContent[1] === 'goods_types' || item.attributeContent[1] === 'goods_num') {
          item.relationOptions = higherAduRelateOpsThree()
        }
        if (item.attributeContent[1] === 'unit_price') {
          item.relationOptions = higherAduRelateOpsFour()
        }
      }
      this.sendValues()
    },
    // 选择之后加载限制属性相对关系
    changeLimitRelation (item, itemAttr) {
      // console.log(item, itemAttr, '20')
      if (itemAttr.attributeContent === 'source') {
        getCustomerSources(1, 0, '').then((res) => {
          if (res.data.code == 200) {
            for (let items of res.data.result.list) {
              items.label = items.name
              items.value = items.id
            }
            itemAttr.sources = res.data.result.list
          }
        })
      }
      for (let yi of item.eventAttributeList) {
        if (itemAttr.attributeContent === yi.attr_identity) {
          itemAttr.attr_type = yi.attr_type
          itemAttr.attr_identity = yi.attr_identity
        }
      }
      itemAttr.attributeRelation = ''
      resetAttr(itemAttr)
      // itemAttr.attributeValue = ''
      // itemAttr.attrValTimeStart = ''
      // itemAttr.attrValTimeEnd = ''
      // itemAttr.attributeValueStart = ''
      // itemAttr.attributeValueEnd = ''
      if (itemAttr.attributeContent === 'source' || itemAttr.attributeContent === 'address') {
        itemAttr.relationOptions = higherAduRelateOpsFive()
      }
      if (itemAttr.attributeContent === 'source_content' || itemAttr.attributeContent === 'serial_number') {
        itemAttr.relationOptions = higherAduRelateOpsOne()
      }
      if (itemAttr.attributeContent !== 'source' || itemAttr.attributeContent !== 'source_content' || itemAttr.attributeContent !== 'serial_number') {
        if (itemAttr.attr_type === 'txt') {
          itemAttr.relationOptions = higherAduRelateReversalOne()
        }
        if (itemAttr.attr_type === 'money') {
          itemAttr.relationOptions = higherAduRelateOpsFour()
        }
        if (itemAttr.attr_type === 'number') {
          itemAttr.relationOptions = higherAduRelateOpsFive()
        }
        if (itemAttr.attr_type === 'dictionary') {
          itemAttr.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            }
          ]
        }
      }
      this.sendValues()
    },
    updates (item) {
      if (item.type === 'dateTimePicker') {
        if (item.relationship === 'gtele' && item.value) {
          item.value = ''
        }
        if (item.relationship !== 'gtele' && item.startValue && item.endValue) {
          item.startValue = ''
          item.endValue = ''
        }
      }
      if (item.type === 'datePicker') {
        if (item.relationship === 'gtele' && item.value) {
          item.value = ''
        }
        if (item.relationship !== 'gtele' && item.startValue && item.endValue) {
          item.startValue = ''
          item.endValue = ''
        }
      }
      // 传值到父组件
      let allTerms = {}
      allTerms.allRelationship = this.outOperator
      for (let item of this.termsGroup) {
        for (let one of item.terms) {
          if (one.relationship === 'empty' || one.relationship === 'not_empty') {
            one.value = ''
          }
          one.attr = one.selectedOptions[0]
        }
      }
      allTerms.termsGroup = this.termsGroup
      this.$emit('change', allTerms)
    },
    getQrcodes (value) {
      this.qrcodes = value
    },
    chooseStartTime (item) {
      // 判断属性的时间类区间开始不能大于结束
      if (Date.parse(new Date(item.startValue)) > Date.parse(new Date(item.endValue))) {
        item.endValue = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
    },
    chooseEndTime (item) {
      // 判断属性的时间类区间开始不能大于结束
      if (Date.parse(new Date(item.startValue)) > Date.parse(new Date(item.endValue))) {
        item.endValue = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
    },
    // 专门传值到父组件
    sendValues (value,type) {
      let allTerms = {}
      allTerms.allRelationship = this.outOperator
      for (let item of this.termsGroup) {
        for (let one of item.terms) {
          one.attr = one.selectedOptions[0]
          if(one.eventTimeRelation === null && type === 'eventTimeRelation') {
            one.eventTimeRelation = value
          }
          if (one.eventTimeRelation && one.attr === 'event') {
            one.relationship = one.eventTimeRelation
          }
          for(let itens of one.selectedOptions){
            if(itens == 'follow_now@select'){
              one.secAttr = 'follow_now@select'
            }else if(itens == 'follow_never@select'){
              one.secAttr = 'follow_never@select'
            }
          }

        }
      }
      allTerms.termsGroup = this.termsGroup
      // console.log(allTerms.termsGroup, 'allTerms.termsGroup========')
      this.$emit('change', allTerms)
    },
    // 事件选择发送微信模板
    updateTemplate (item) {
      this.sendValues()
    },
    // 切换微信回复类型
    updateReplyTypes (item) {
      item.public_reply_type_all.reply_content = null
      this.sendValues()
    },
    // 事件选完传值
    updateEvent (item) {
      this.sendValues()
    },
    // 事件选择公众号离开的时候
    eventChange (item) {
      // console.log('事件选择公众号离开的时候 item', item)
      // 如果是关注公众号  将公众号的原始id也放进去
      if (item.selectedOptions[0] === 'follow_public') {
        for (let yi of item.option) {
          if (parseInt(yi.id) === parseInt(item.value)) {
            item.original_id = yi.original_id
          }
        }
      }
      // 如果是微信  将公众号的原始id也放进去
      if (item.selectedOptions[1] === 'wechat') {
        for (let yi of item.option) {
          if (yi.id === item.value) {
            item.original_id = yi.original_id
          }
        }
      }
      // 处理公众号二维码选择问题
      if (item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'scan_qrcode') {
        for (let j in item.option) {
          if (item.value === item.option[j].id) {
            if (item.option[j].qrcode.length !== 0 && item.option[j].qrcode[0].title !== '不限') {
              item.option[j].qrcode.unshift({
                title: '不限',
                id: ''
              })
            }
            if (item.option[j].qrcode.length === 0) {
              item.option[j].qrcode.unshift({
                title: '不限',
                id: ''
              })
            }
            item.qrcodeOptions = item.option[j].qrcode
          }
        }
        item.qrcode = ''
      }
      // 处理线下活动二维码选择问题
      if (item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'scan_offline_qrcode') {
        for (let j in item.option) {
          if (item.value === item.option[j].id) {
            item.optionOther = item.option[j].offline
          }
        }
        item.offline_qrcode = ''
      }
      // 处理事件选择发送微信模板
      if (item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'send_tpl_message') {
        for (let i in item.option) {
          if (item.value === item.option[i].id) {
            for (let one of item.option[i].template) {
              one.title = one.message_title
            }
            item.templateOption = JSON.parse(JSON.stringify(item.option[i].template))
            if (item.templateOption.length > 0 && item.templateOption[0].title !== '不限') {
              item.templateOption.unshift({
                title: '不限',
                message_title: '不限',
                id: ''
              })
            }
            if (item.templateOption.length === 0) {
              item.templateOption.unshift({
                title: '不限',
                message_title: '不限',
                id: ''
              })
            }
          }
        }
        item.template_id = ''
      }
      // 处理事件微信客服回复  选择回复微信模板
      if (item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'public_to_reply') {
        item.public_reply_type_all.reply_content = null
        for (let i in item.option) {
          if (item.value === item.option[i].id) {
            // 模板消息
            let dataOne = JSON.parse(JSON.stringify(item.option[i].template))
            for (let one of dataOne) {
              one.name = one.message_title
              one.label = one.message_title
            }
            item.templatesTwo = dataOne
            item.templatesTwo.unshift({
              label: '不限',
              name: '不限'
            })
            // 大转盘
            let dataTwo = JSON.parse(JSON.stringify(item.option[i].lottery))
            for (let one of dataTwo) {
              one.label = one.name
            }
            item.activitiesTwo = dataTwo
            item.activitiesTwo.unshift({
              label: '不限',
              name: '不限'
            })
            // 微页面
            let dataThree = JSON.parse(JSON.stringify(item.option[i].scene))
            for (let one of dataThree) {
              one.label = one.admin_title
            }
            item.wepageTwo = dataThree
            item.wepageTwo.unshift({
              label: '不限',
              name: '不限'
            })
          }
        }
        item.template_id = ''
      }
      this.sendValues()
    },
    // 第一个属性群组事件等选择传值到父组件
    update (item) {
      // console.log(item, 'item======')
      // 解决change报错问题`
      if (typeof item !== 'undefined' && typeof item.value !== 'undefined') {
        // 判断属性对相对关系赋值
        item.relationship = ''
        item.relationOptions = []
        let relationOptions = []
        // 文本
        if (item.selectedOptions[0] === 'customer_kpi' && item.selectedOptions[1].split('@')[1] === 'number') {
          relationOptions = higherAduRelateOpsSix()
        }
        if (item.selectedOptions[0] === 'follow_public' && item.selectedOptions[1].split('@')[1] === 'select') {
          item.option = []
          getWechatPublicListAll(1, this.modelId).then(res => {
            let array = []
            for (let it of res.data.data.list) {
              array.push({
                value: it.original_id,
                label: it.nick_name
              })
            }
            item.option = array
          })
        }

        //受众身份  微信openId
        if (item.selectedOptions[0] === 'wechat_open_id' && item.selectedOptions[1].split('@')[1] === 'input') {
          relationOptions = higherAduRelateOpsFive()
        }

        if (item.selectedOptions[0] === 'attr') {
          /* -------------自定义属性的相对关系------------ */
          // 文本
          if (item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = higherAduRelateOpsOne()
          }

          // 地址 单个选择列表
          if (selDicAddList.includes(item.selectedOptions[1].split('@')[1])) {
            relationOptions = higherAduRelateOpsFive()
          }
          // 时间
          if (datePickerArr.includes(item.selectedOptions[1].split('@')[1])) {
            relationOptions = higherAduRelateOpsEight()
          }

          // 多个选择列表  ||  关联模型
          if (multipleModelList.includes(item.selectedOptions[1].split('@')[1])) {
            relationOptions = higherAduRelateOpsSeven()
          }
          // 数值
          if (item.selectedOptions[1].split('@')[1] === 'number') {
            // higherAduRelateOpsSix : 等于 不等于 大于 小于 区间
            relationOptions = higherAduRelateOpsSix()
          }

        }
        if (item.selectedOptions[0] === 'aud_portary') {
          /* -------------自定义属性的相对关系------------ */
          // 文本
          if (item.selectedOptions[1].split('@')[0] === 'tag') {
            relationOptions = higherAduRelateOpsSeven()
          }
        }
        if (item.selectedOptions[0] === 'customer_kpi' && item.selectedOptions[1].split('@')[1] === 'number') {
          relationOptions = higherAduRelateOpsSix()
        }
        if (item.selectedOptions[0] === 'follow_public' && item.selectedOptions[1].split('@')[1] === 'select') {
          item.option = []
          getWechatPublicListAll(1, this.modelId).then(res => {
            let array = []
            for (let it of res.data.data.list) {
              array.push({
                value: it.original_id,
                label: it.nick_name
              })
            }
            item.option = array
          })
        }
        item.relationOptions = relationOptions
        if (item.selectedOptions[0] === 'group') {
          item.value = []
        } else {
          item.value = null
        }
        // item.qrcode = null
        // item.offline_qrcode = null
        // item.template_id = null
        // item.optionOther = null
        // item.qrcodeOptions = null
        // item.templateOption = null
        // item.public_reply_type_all.reply_type = '不限'
        // item.public_reply_type_all.reply_content = null
        // 获取option的选项值
        let str = ''
        if (item.selectedOptions[0] !== 'event') {
          str = item.selectedOptions[1].split('@')
        }
        // 切换事件清空限制属性
        if (item.attr === 'event' && item.eventLimitAttr) {
          item.eventLimitAttr = false
          for (let it of item.eventAttrOptions) {
            it.attr_identity = ''
            it.attributeContent = ''
            it.attr_type = ''
            it.attributeRelation = ''
          }
        }

        // 切换事件清空限制次数
        if (item.attr === 'event' && item.eventLimitTimes) {
          item.eventLimitTimes = false
          item.happenedTimes = null
          item.happenedTimesStart = null
          item.happenedTimesEnd = null
        }

        item.type = str[1]
        for (let one of this.options) {
          for (let i in one.children) {
            // 处理属性的option
            if (one.value === 'attr') {
              if (str[0] === one.children[i].identity) {
                if (str[0] !== 'stage_id' && str[0] !== 'source_id' && str[1] !== 'model') {
                  if (one.children[i].options !== '') {
                    item.option = JSON.parse(one.children[i].options)
                    this.$emit('handleStageUse',item.option)
                  }
                }
                if (str[0] === 'stage_id' || str[0] === 'source_id') {
                  item.option = one.children[i].option
                  this.$emit('handleStageUse',item.option)
                }
                if (str[1] === 'model') {
                  let modelId = JSON.parse(one.children[i].options)[0].modelId
                  let identity = JSON.parse(one.children[i].options)[2].identity
                  getMyAboutModelList(modelId, identity, this.queryString).then((res) => {
                    if (res.data.code == 200) {
                      item.option = res.data.result.list
                      this.$emit('handleStageUse',item.option)
                    }
                  })
                }
                item.attr_label = one.children[i].label
              }
            }
            // 处理事件的attr
            if (one.value === 'event') {
              // console.log(one.children[i].children, '处理事件下拉')
              for (let j of one.children[i].children) {
                if (item.selectedOptions[2] === j.value) {
                  item.eventAttributeList = j.eventAttributeList
                }
              }
            }
            // 处理群组
            if (one.value === 'group') {
              // console.log('处理群组')
              // console.log(one.children[i], '处理群组')
              if (str[0] === one.children[i].identity) {
                item.option = one.children[i].option
                item.attr_label = one.children[i].label
                item.value = one.children[i].id
              }
            }
            // 处理标签
            if (one.value === 'aud_portary') {
              if (str[0] === one.children[i].identity) {
                item.attr_label = one.children[i].label
              }
            }

            // 受众关键指标
            if (one.value === 'customer_kpi') {
              if (str[0] === one.children[i].identity) {
                item.attr_label = one.children[i].label
              }
            }

            // 受众身份
            if (one.value === 'wechat_open_id') {
              if (str[0] === one.children[i].identity) {
                item.attr_label = one.children[i].label
              }
            }
            // // 处理标签   受众关键指标  受众身份
            // if (optionsValueArr.includes(one.value)) {
            //   if (str[0] === one.children[i].identity) {
            //     item.attr_label = one.children[i].label
            //   }
            // }
          }
        }
      }
      // 传值到父组件
      let allTerms = {}
      allTerms.allRelationship = this.outOperator
      for (let item of this.termsGroup) {
        for (let one of item.terms) {
          one.attr = one.selectedOptions[0]
        }
      }
      allTerms.termsGroup = this.termsGroup
      console.log('传值到付组件=======',allTerms)
      this.$emit('change', allTerms)
    },
    updateQrcodes (item) {
      this.sendValues()
    },
    updateQrcode (item) {
      this.sendValues()
    },
    // 添加一组查询条件
    addNewTermGroup () {
      this.termsGroup.push({
        inOperator: 'and',
        terms: [{
          attr: 'attr',
          attr_label: '',
          relationship: '',
          relationOptions: [],
          value: null,
          option: [],
          startValue: '',
          endValue: '',
          //            original_id: null,
          //            eventAttributeList: [],
          //            activitiesTwo: [],
          //            templatesTwo: [],
          //            wepageTwo: [],
          eventAttrOptions: [{
            attributeContent: '',
            relationOptions: [],
            sources: [],
            eventAttrValueOptions: [],
            attributeRelation: '',
            attr_type: '',
            attr_identity: '',
            attrValTimeStart: '',
            attrValTimeEnd: '',
            attributeValueStart: '',
            attributeValueEnd: '',
            attributeValue: ''
          }],
          //            optionOther: null,
          //            qrcodeOptions: null,
          //            templateOption: null,
          //            qrcode: null,
          //            offline_qrcode: null,
          //            template_id: null,
          //            leave_word: null,
          //            public_reply_type_all: {
          //              reply_type: '不限',
          //              reply_content: ''
          //            },
          eventLimitTime: false,
          eventLimitTimes: false,
          eventLimitAttr: false,
          eventTimeRelation: null,
          //            eventDateStart: '',
          //            eventDateEnd: '',
          happenedTimes: null,
          //            start_time: '',
          //            end_time: '',
          selectedOptions: ['attr', '']
        }]
      })
    },
    // 删除当前这条查询条件
    removeTermItem (index, i) {
      this.termsGroup[i].terms.splice(index, 1)
      if (this.termsGroup[i].terms.length === 0) {
        this.termsGroup.splice(i, 1)
      }
    },
    // 添加一条查询条件
    addNewTerm (i) {
      this.termsGroup[i].terms.push({
        attr: 'attr',
        attr_label: '',
        relationship: '',
        relationOptions: [],
        value: null,
        option: [],
        startValue: '',
        endValue: '',
        eventAttrOptions: [
          {
            attributeContent: '',
            relationOptions: [],
            sources: [],
            eventAttrValueOptions: [],
            attributeRelation: '',
            attr_type: '',
            attr_identity: '',
            attrValTimeStart: '',
            attrValTimeEnd: '',
            attributeValueStart: '',
            attributeValueEnd: '',
            attributeValue: ''
          }
        ],
        eventLimitTime: false, // 限制时间
        eventLimitTimes: false, // 限制次数
        eventLimitAttr: false,
        selectedOptions: ['attr', '']
      })
    },
    // 处理地址选择
    handleAddressChange (value) {
    },
    // 条件选择
    handleChange (value) {
    },
    // 加载
    load (modelId) {
      // 获取属性列表
      if (!modelId && this.$route.params.id) {
        modelId = this.$route.params.id
      }
      if (!modelId && !this.$route.params.id) {
        modelId = this.modelId
      }
      // 获取属性
      let getAttr = getCusAttrList(modelId)
      // 获取事件
      let getEvent = getCusEventList(1, 0, '')
      // 获取群组
      let getGroup = getAudGroupList(modelId, 1, 1000000000, '', '')
      // 发送promiss请求并处理
      Promise.all([getAttr, getEvent, getGroup]).then(async res => {
        // 处理属性
        if (res[0].data.code == 200) {
          let data = res[0].data.result
          let remainData = []
          for (let i in data) {
            if (data[i].identity === 'source_id') {
              getCustomerSources(1, 10000, '').then((res) => {
                data[i].option = []
                for (let item of res.data.result.list) {
                  data[i].option.push({
                    name: item.name,
                    id: item.id
                  })
                }
              })
            }
            if (data[i].identity === 'stage_id') {
              let modelId = ''
              if (this.$route.params.id) {
                modelId = this.$route.params.id
              } else {
                modelId = this.modelId
              }
              getCusStageList(modelId).then((res) => {
                data[i].option = [
                  {
                    name: '未知等级',
                    id: 0
                  }
                ]
                for (let item of res.data.result) {
                  data[i].option.push({
                    name: item.name,
                    id: item.id
                  })
                }
              })
            }
            if (data[i].isNormal !== 0) {
              remainData.push(data[i])
            }
          }
          // 拼接处理获得的属性列表到本地数据
          for (let i in remainData) {
            remainData[i].value = remainData[i].identity + '@' + remainData[i].type
            remainData[i].label = remainData[i].name
          }
          this.options[0].children = remainData
        }
        // 处理事件
        if (res[1].data.code == 200) {
          // 请求分组
          getCusEventGroupList().then( (resp) => {
            // console.log(resp.data.result, 'resprespresprespresp')
            if (resp.data.code == 200) {
              // 设置分组
              resp.data.result.unshift({
                id: 0,
                name: '全部'
              })
              for (let item of resp.data.result) {
                item.children = []
                item.label = item.name
                item.value = item.id + '@'
              }
              // console.log(res[1].data.result.list, 'ooooooooooooooooooo----------')
              // 普通分组事件
              for (let one of res[1].data.result.list) {
                for (let item of resp.data.result) {
                  if (one.groupId == item.id) {
                    item.children.push({
                      label: one.name,
                      value: one.identity,
                      eventAttributeList: JSON.parse(one.attr)
                    })
                  }
                }
              }
              // 全部分组事件
              resp.data.result[0].children = []
              for (let one of res[1].data.result.list) {
                resp.data.result[0].children.push({
                  label: one.name,
                  value: one.identity,
                  eventAttributeList: JSON.parse(one.attr)
                })
              }
              this.options[1].children = resp.data.result
            }
          })
        }

        if (res[2].data.code == 200) {
          // 获取群组分组
          // getAudGroupGroupList(modelId, '').then((respo) => {
          const respo = await getAudGroupGroupList(modelId, '')
          // 处理群组
          if (respo.data.code == 200) {
            let option = []
            // 设置分组
            respo.data.result.unshift({
              id: 0,
              name: '全部'
            })
            for (let item of respo.data.result) {
              item.children = []
              item.label = item.name
              item.value = item.id
            }
            // 普通分组群组
            for (let one of res[2].data.result.list) {
              for (let item of respo.data.result) {
                if (one.groupId == item.id) {
                  item.children.push({
                    label: one.name,
                    value: one.id
                  })
                }
              }
            }
            // 全部分组群组
            respo.data.result[0].children = []
            for (let one of res[2].data.result.list) {
              respo.data.result[0].children.push({
                label: one.name,
                value: one.id,
              })
            }
            option = respo.data.result
            this.options[2].children = []
            // if (this.options[2].children.length === 0) {
            this.options[2].children.push(
                    {
                      label: '在此群组中',
                      value: 'inGroup@select',
                      option,
                      identity: 'inGroup'
                    }
            )
            this.options[2].children.push(
                    {
                      label: '不在此群组中',
                      value: 'notInGroup@select',
                      option,
                      identity: 'notInGroup'
                    }
            )
          }
          // })
        }
      })
      if (this.allRelationship) {
        this.outOperator = this.allRelationship
      } else if (this.allRelationshipSearch) {
        this.outOperator = this.allRelationshipSearch
      }
    }
  },
  mounted () {
  },
  created () {
    // this.update()
    this.load()
  }
}
</script>

<style scoped>
</style>
